<template>
  <section class="hd-doc" aria-labelledby="hazte-duena-doc-title">
    <img class="hd-doc__image" :src="image" alt="Mujer sonriendo al aire libre">

    <div class="hd-doc__content">
      <span class="hd-doc__tag">Documentación</span>

      <div class="hd-doc__text">
        <h2 id="hazte-duena-doc-title" class="hd-doc__title">Lo que necesitarás <br class="br-m">para tu proceso</h2>
        <p class="wd-body">
          Reúne esta documentación para que <br class="br-m">tu proceso avance <br class="br-d">sin contratiempos.
        </p>
      </div>

      <ul class="hd-doc__items">
        <li v-for="item in items" :key="item.icon" class="hd-doc__item">
          <img :src="item.icon" alt="" aria-hidden="true">
          <span class="wd-body" v-html="item.text" />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import image from '../../../assets/hazte-duena-figma/documentacion.jpg'
import idIcon from '../../../assets/hazte-duena-figma/doc-id.svg'
import incomeIcon from '../../../assets/hazte-duena-figma/doc-income.svg'
import legalIcon from '../../../assets/hazte-duena-figma/doc-legal.svg'
import alertIcon from '../../../assets/hazte-duena-figma/doc-alert.svg'

const items = [
  { icon: idIcon, text: 'Identificación Oficial (INE)' },
  { icon: incomeIcon, text: 'Comprobantes de ingresos (recibos, facturas, <br>estados de cuenta recientes, declaraciones fiscales)' },
  { icon: legalIcon, text: 'Información legal y de ubicación del inmueble' },
  { icon: alertIcon, text: '<strong>RECUERDA QUE NO ACEPTAMOS</strong>: Inmuebles con <br>problemas legales o ingresos inconsistentes.' }
]
</script>

<style scoped>
.hd-doc { display: flex; align-items: stretch; gap: var(--ds-space-5); }

.hd-doc__image {
  flex: 0 0 370px;
  width: 370px;
  min-width: 0;
  object-fit: cover;
  border-radius: 24px;
}

.hd-doc__content {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--ds-space-5);
  min-width: 0;
}

.hd-doc__tag {
  display: inline-flex;
  align-items: center;
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.hd-doc__text { display: flex; flex-direction: column; gap: var(--ds-space-3); width: 100%; }
.hd-doc__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

.hd-doc__items { display: flex; flex-direction: column; gap: var(--ds-space-6); width: 100%; margin: 0; padding: 0; list-style: none; }
.hd-doc__item { display: flex; align-items: center; gap: var(--ds-space-3); min-height: 40px; }
.hd-doc__item img { flex: 0 0 40px; width: 40px; height: 40px; }
.hd-doc__item :deep(strong) { font-weight: 700; }

@media (max-width: 1024px) {
  .hd-doc__image { flex-basis: 340px; width: 340px; }
}

@media (max-width: 599px) {
  .hd-doc { flex-direction: column; padding: var(--ds-space-5) 0; }
  .hd-doc__image { flex: none; width: 100%; height: auto; aspect-ratio: 1 / 1; }
  .hd-doc__content { flex: none; justify-content: flex-start; width: 100%; }
}
</style>
